



















import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "TextField",
  props: {
    invalid: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: "medium",
      validator(value: string) {
        return ["medium", "large"].includes(value);
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 理想としてはAtomにwidthを指定したくないが、このコンポーネントの使用箇所が多く影響範囲が広いので暫定的な対応としてminWidthを外から渡せるようにする
    minWidth: {
      type: String,
      default: "300px"
    }
  },
  data() {
    return {
      isComposing: false
    };
  },
  computed: {
    invalidClass() {
      return {
        "textField--invalid": this.invalid
      };
    },
    sizeClass() {
      return {
        "textField--size--medium": this.size === "medium",
        "textField--size--large": this.size === "large"
      };
    }
  },
  methods: {
    updateValue(event: Event) {
      if (event.target instanceof HTMLInputElement) {
        const stringValue = event.target.value;
        const value =
          this.type === "number" && stringValue !== ""
            ? Number(stringValue)
            : stringValue;

        this.$emit("input", value);
        this.$emit("change", value);
      }
    },
    handleComposition(value: boolean) {
      this.isComposing = value;
    },
    handleEnter(event: Event) {
      if (this.isComposing) {
        return;
      }
      this.$emit("enter", event);
    }
  }
});
